// extracted by mini-css-extract-plugin
export var primitiveLabel = "_uf-0";